<template>
    <div class="footerDiv">
      <div class="footMain tw-flex">
        <div class="footMainLi contactUs tw-flex tw-justify-center">
          <div class="footMainLiContactusBg tw-flex tw-flex-col tw-justify-center">
            <img class="logoImg" src="../../static/images/codeLogo.png">
            <div class="weightWord">联系我们</div>
            <div class="emil">邮箱:sky-code@singularity-ai.com</div>
            <div>商务联系: bd@singularity-ai.com</div>
          </div>
        </div>
        <div class="footMainLi footMainLiCenter tw-flex tw-justify-center">
          <div class="footMainLiNavigationBg tw-flex tw-flex-col tw-justify-center">
            <div class="button">导航</div>
            <div class="wordName" @click="jumpDocPageBtn">SkyCode文档</div>
            <div class="privacyTerms"><a :href="$axiosUrl.PrivacyTermsSrc" target="_blank">隐私条款</a></div>
            <div><a :href="$axiosUrl.UserAgreementSrc" target="_blank">用户协议</a></div>
          </div>
        </div>
        <div class="footMainLi ereweimaDiv">
          <div class="erweimaBg">
            <div class="title">微信交流群</div>
            <img src="../../static/images/SkyCode.jpeg" alt="">
          </div>
        </div>
      </div>
      <div class="put-on-record">京ICP备2021027167号   Singularity AI. © 2022 All Rights Reserved <slot name="agreementDiv"></slot></div>
      <!-- <div class="jingCode">京ICP备2021027167号</div>
      <slot name="email"></slot> -->
    </div>
</template>

<script>
export default {
  name: 'footerDiv',
  data () {
    return {
    }
  },
  props: {
    nowActivePor: {
      type: String,
      default: ''
    },
  },
  mounted () {
  },
  // watch的作用是：父组件数据修改后，子组件未变动（修改）
  watch: {
    nowActivePor: {
      immediate: true,
      handler (val) {
        this.nowActive = val
      }
    }
  },
  methods: {
    jumpDocPageBtn() {
      this.$router.push('/documentIndex')
    }
  }
}
</script>

<style scoped lang="less">
  .footerDiv {
    width: 100%;
    min-height: 565px;
    background-color: #060714;
    font-size: 16px;
    font-weight: 400;
    color: #F3F5F7;
    // padding: 0 18.75vw;
    .footMain {
      // grid-template-columns: repeat(auto-fill, 400px);
      flex-flow: wrap; 
      justify-content: center;
      // border: 1px solid #262840;
      border-radius: 20px;
      .footMainLi {
        // width: 400px;
        // height: 397px;
        width: 20.8333vw;
        min-width: 257px;
        border: 1px solid #262840;
        .footMainLiContactusBg {
          width: 245px;
        }
        .footMainLiNavigationBg {
          width: 110px;
        }
      }
      .footMainLi:first-child {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
      .footMainLi:last-child {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
      .contactUs {
        // padding: 80px 0 0 80px;
        padding: 4.1666vw 0 4.1666vw 0;
        .logoImg {
          // width: 162px;
          // height: 36px;
          width: 6.7708vw;
          height: 1.5104vw;
        }
        .weightWord {
          font-weight: 700;
          margin-top: 72px;
        }
        .emil{
          margin: 18px 0 20px 0;
        }
      }
      .footMainLiCenter {
        // padding: 93px 0 0 80px;
        padding: 4.843vw 0 4.1666vw 0;
        .button  {
          font-weight: 600;
          font-size: 20px;
          line-height: 24px;
        }
        .wordName {
          margin-top: 70px;
          cursor: pointer;
        }
        .privacyTerms {
          margin: 20px 0;
        }
        a {
          color: #f3f5f7 !important;
        }
      }
      .ereweimaDiv {
        // padding: 79px 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        .erweimaBg {
          // width: 200px;
          // height: 239px;
          max-width: 200px;
          // width: 10.416vw;
          border: 1px solid #262840;
          border-radius: 12px;
          padding-top: 20px;
          .title {
            text-align: center;
            color: #FFF3F3;;
          }
          img {
            // width: 160px;
            // height: 160px;
            max-width: 160px;
            width: 8.333vw;
            margin: 20px;
          }
        }
      }
    }
    .put-on-record {
      margin-top: 40px;
      padding-bottom: 101px;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #7780A1;
    }
  }
</style>